import getStore from '../store/store';
import type { MailboxInfo } from 'owa-client-types';
import { getAccountKeyForMailboxInfo } from 'owa-client-types';
import { isUnifiedInboxMailboxInfo } from 'owa-client-types/lib/UnifiedInboxMailboxInfo';
import { getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';

export function getIsCopilotUIDisabled(mailboxInfo: MailboxInfo): boolean {
    // Handle UIB by considering the real mailboxInfo that will be used for copilot
    const effectiveMailboxInfo = isUnifiedInboxMailboxInfo(mailboxInfo)
        ? getGlobalSettingsAccountMailboxInfo()
        : mailboxInfo;

    const accountKey = getAccountKeyForMailboxInfo(effectiveMailboxInfo);
    return !!getStore().copilotGeneralPreferencesMap.get(accountKey)?.isCopilotUIDisabled;
}
